module.exports = __webpack_public_path__ + "img/posterSearch-des10.43a289f5.png";